import LoggedInUser from './LoggedInUser'
import Helpers from './Helpers';

export function search(search, limit, offset) {
    return fetch(Helpers.endpoint("/query"), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            auth_token: LoggedInUser.getInfo().auth_token,
            query: {
                search: search,
                offset: offset,
                limit: limit,
                admin_mode: true,
                type: "user"
            }
        })
    }).then((response) => response.json())
}

export function user(swipecast_user_id) {
    return fetch(Helpers.endpoint("/admin/user/"+swipecast_user_id+"?auth_token=" + LoggedInUser.getInfo().auth_token), {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => response.json())
}

export function deleteProfile(swipecast_profile_id) {
    return fetch(Helpers.endpoint('/delete_profile'), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            swipecast_profile_id: swipecast_profile_id,
            auth_token: LoggedInUser.getInfo().auth_token
        })
    }).then((response) => response.json())
}

export function addProfile(profile_type, swipecast_user_id) {
    return fetch(Helpers.endpoint('/add_profile'), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            profile_type: profile_type,
            swipecast_user_id: swipecast_user_id,
            auth_token: LoggedInUser.getInfo().auth_token
        })
    }).then((response) => response.json())
}

export function updateUser(swipecast_user_id, fields) {
    return fetch(Helpers.endpoint("/update_user"), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            auth_token: LoggedInUser.getInfo().auth_token,
            swipecast_user_id,
            user: fields,
        })
    }).then((response) => response.json())
}

export function updateProfile(swipecast_profile_id, fields) {
    return fetch(Helpers.endpoint('/update_profile'), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            swipecast_profile_id: swipecast_profile_id,
            auth_token: LoggedInUser.getInfo().auth_token,
            profile: fields
        })
    }).then((response) => response.json())
}

export function deleteUser(swipecast_profile_id) {
    return fetch(Helpers.endpoint('/delete_user'), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            swipecast_user_id: swipecast_profile_id,
            auth_token: LoggedInUser.getInfo().auth_token
        })
    }).then((response) => response.json())
}

export function fixStripe(swipecast_profile_id) {
    return fetch(Helpers.endpoint('/fix_stripe'), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            swipecast_user_id: swipecast_profile_id,
            auth_token: LoggedInUser.getInfo().auth_token
        })
    }).then((response) => response.json())
}